import React, { useState, useEffect } from "react";
import { useAuth } from "../../../../../context/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import "primeicons/primeicons.css"; // DOM'u bozmayan ikon setini dahil ediyoruz

export const InactiveUsersReport = () => {
    const { user } = useAuth();
    const currentUserId = user.user.id || user.nameid;

    // Filtre Stateleri
    const [days, setDays] = useState("7");
    const [userType, setUserType] = useState("all");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Express API Adresi
    const API_URL = "https://express.heryerdeingilizce.com/api/user-trace/inactive-report";

    // RAPORU GETİR
    const fetchInactiveReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(API_URL, {
                params: {
                    days: days,
                    userType: userType,
                    schoolId: user.role === "Admin" ? null : user.userDetail?.schoolId
                }
            });
            console.log(response)
            if (response.data.success) {
                setReportData(response.data.data);
            } else {
                Swal.fire("Hata", "Veriler alınamadı.", "error");
            }
        } catch (error) {
            console.error("Rapor hatası:", error);
            Swal.fire("Hata", "Sunucuya bağlanılamadı.", "error");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchInactiveReport();
    }, []);

    const renderUserTypeBadge = (type) => {
        const types = {
            manager: { text: "Manager", class: "bg-info" },
            teacher: { text: "Öğretmen", class: "bg-warning text-dark" },
            schoolstudent: { text: "Okul Öğrencisi", class: "bg-primary" },
            individualstudent: { text: "Bireysel Öğrenci", class: "bg-secondary" },
            admin: { text: "Admin", class: "bg-danger" }
        };
        const item = types[type] || { text: type, class: "bg-light text-dark" };
        return <span className={`badge ${item.class}`}>{item.text}</span>;
    };

    return (
        <div className="container-fluid py-4" translate="no">
            <div className="text-center mb-4">
                <h1 className="fw-bold">Kullanıcı Etkinlik Raporu</h1>
                <p className="text-muted">Sisteme belirli süredir giriş yapmayan kullanıcıların listesi</p>
            </div>

            {/* FİLTRELEME ALANI */}
            <div className="card shadow-sm border-0 mb-4 bg-light">
                <div className="card-body">
                    <div className="row align-items-end">
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="form-label fw-bold">Kullanıcı Türü</label>
                            <select
                                className="form-select shadow-sm"
                                value={userType}
                                onChange={(e) => setUserType(e.target.value)}
                            >
                                <option value="all">Tümü</option>
                                <option value="manager">Managerlar</option>
                                <option value="teacher">Öğretmenler</option>
                                <option value="schoolstudent">Okul Öğrencileri</option>
                                <option value="individualstudent">Bireysel Öğrenciler</option>
                            </select>
                        </div>
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="form-label fw-bold">Hareketsizlik Süresi</label>
                            <select
                                className="form-select shadow-sm"
                                value={days}
                                onChange={(e) => setDays(e.target.value)}
                            >
                                <option value="7">1 Haftadır Girmeyenler</option>
                                <option value="15">15 Gündür Girmeyenler</option>
                                <option value="30">1 Aydır Girmeyenler</option>
                                <option value="90">3 Aydır Girmeyenler</option>
                                <option value="180">6 Aydır Girmeyenler</option>
                            </select>
                        </div>
                        <div className="col-md-4 text-md-end">
                            {loading ? (
                                <button className="btn btn-primary btn-lg px-5 shadow-sm" disabled>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    <span>Yükleniyor...</span>
                                </button>
                            ) : (
                                <button className="btn btn-primary btn-lg px-5 shadow-sm" onClick={fetchInactiveReport}>
                                    {/* FONT AWESOME YERİNE PRIME ICONS KULLANILDI */}
                                    <i className="pi pi-search me-2"></i>
                                    <span>Listeyi Getir</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* SONUÇ TABLOSU */}
            <div className="card shadow-sm border-0">
                <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 fw-bold">Sonuçlar ({reportData.length} Kullanıcı)</h5>
                    <button className="btn btn-sm btn-outline-success" onClick={() => window.print()}>
                        <i className="pi pi-print me-1"></i> Yazdır
                    </button>
                </div>

                <div className="card-body p-0">

                    {/* KEY DEĞERLERİ EKLENDİ - REACT HİÇBİR ZAMAN DOM İÇİNDE KAYBOLMAYACAK */}
                    {loading ? (
                        <div key="state-loading" className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2 text-muted">Veriler analiz ediliyor...</p>
                        </div>
                    ) : reportData.length > 0 ? (
                        <div key="state-data" className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="px-4">Ad Soyad</th>
                                        <th>Tür</th>
                                        <th>Son Giriş Tarihi</th>
                                        <th className="text-center">Geçen Süre</th>
                                        <th className="text-center">İşlem</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.map((item) => (
                                        <tr key={`user-${item.user_id}`}>
                                            <td className="px-4 fw-bold">{item.full_name}</td>
                                            <td>{renderUserTypeBadge(item.user_type)}</td>
                                            <td className="text-muted">
                                                {new Date(item.last_login_at).toLocaleString("tr-TR", {
                                                    day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit'
                                                })}
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2">
                                                    {item.inactive_days} Gün
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <button className="btn btn-sm btn-outline-primary" title="Mesaj Gönder">
                                                    <i className="pi pi-send"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div key="state-empty" className="text-center py-5 text-muted">
                            <i className="pi pi-users mb-3" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                            <p>Belirtilen kriterlerde inaktif kullanıcı bulunamadı.</p>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default InactiveUsersReport;